























































































































































































































import Vue from 'vue';
import TopNav from '@/web/components/navigation/TopNav.vue';
import { getConfig } from '@/web/utils/configuration';
import HMSpinner from '@/web/components/common/HMSpinner.vue';
import HMCheckBox from '@/web/components/common/HMCheckBox.vue';
import { notify } from '@/web/utils/notify';
import HMTextInput from '@/web/components/common/HMTextInput.vue';
import { ValidationObserver } from 'vee-validate';
import AffiliatePayoutHistoryModal from '@/web/components/affiliates/AffiliatePayoutHistoryModal.vue';
import { sanitize } from '@/core/utils/utils';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'ShareAndEarn',
  components: {
    HMTextInput,
    HMCheckBox,
    HMSpinner,
    TopNav,
    ValidationObserver,
  },
  computed: {
    ...mapGetters({
      isExternalAffiliate: 'user/isExternalAffiliate',
    }),
    config() {
      return getConfig();
    },
    applicationName() {
      return this.config.applicationName;
    },
    teamEmail() {
      return this.config.teamEmail;
    },
    affiliateUrl(): string {
      const host = window.location.host;
      const protocol = window.location.protocol;
      const uri = encodeURI(
        `${protocol}//${host}/signup?ref=${this.affiliateInfo.code}`
      );
      return uri;
    },
    affiliateCommissionAmount() {
      if (this.affiliateInfo?.commission_percent)
        return `${this.affiliateInfo.commission_percent}%`;
      return `$${this.affiliateInfo?.commission_flat}`;
    },
  },
  data() {
    return {
      isLoading: true,
      affiliateInfo: null,
      affiliateStats: null,
      agree: false,
    };
  },
  methods: {
    sanitize,
    openPaymentHistoryModal() {
      this.$modal.show(AffiliatePayoutHistoryModal, {
        paymentHistory: this.affiliateStats.payout_history,
      });
    },
    copyAffLink() {
      const value = this.affiliateUrl;
      this.$copyText(value).then(() => {
        notify(this.$t('PRODUCTS.TOAST.COPIED') as string, value);
      });
    },
    async loadAffiliateInfo() {
      this.isLoading = true;
      try {
        this.affiliateInfo = await this.$store.dispatch(
          'user/getAffiliateInfo'
        );
        this.affiliateStats = await this.$store.dispatch(
          'affiliates/getAffiliateStats'
        );
      } catch (e) {
        // affiliate doesn't exist
      } finally {
        this.isLoading = false;
      }
    },
    async createAffiliate() {
      await this.updateAffiliateInfo();
      await this.loadAffiliateInfo();
    },
    async updateAffiliateInfo() {
      this.isLoading = true;
      try {
        this.affiliateInfo = await this.$store.dispatch(
          'user/updateAffiliateInfo',
          this.affiliateInfo
        );
      } catch (e) {
        // affiliate doesn't exist
      } finally {
        this.isLoading = false;
      }
    },
  },
  async mounted() {
    await this.loadAffiliateInfo();
  },
});
